import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import MainRouter from './components/Router/MainRouter';
import AppErrorBoundary from './components/ErrorBoundary/ErrorBoundary';
import { ICustomWindowWithData } from '@interfaces/ICustomWindow';
import AppContextProvider from './components/Template/Context/AppContextProvider';
import GrommetWrapper from './components/Template/GrommetWrapper/GrommetWrapper';

declare const window: ICustomWindowWithData;

const AppRoot: React.FC = () => {
  return (
    <AppContextProvider context={window.__INITIAL_DATA__.context}>
      <BrowserRouter>
        <AppErrorBoundary>
          <GrommetWrapper>
            <MainRouter />
          </GrommetWrapper>
        </AppErrorBoundary>
      </BrowserRouter>
    </AppContextProvider>
  );
};

ReactDOM.hydrateRoot(document.getElementById('root')!, <AppRoot />);

export default AppRoot;
